
<script setup>
  import { useRouter } from 'vue-router';
  import { LocationSearch, VendorSelector, useOrderStore } from 'shared-vue'

  const orderStore = useOrderStore();
  const router = useRouter();

  function vendorSelected(slug) {
    //orderStore.setVendor(vendor);
    router.push('/restaurant/'+slug.slug);
  }
</script>

<template>
  <div class="my-4">
    <LocationSearch />
  </div>
  <div>
    <!--<h1>Select a Vendor</h1>-->
    <VendorSelector :onSelected="vendorSelected" />
  </div>
</template>

